import { BrowserRouter } from 'react-router-dom'
import { useEffect } from 'react'
import { Provider } from 'react-redux'
import RoutesComponent from 'src/view/shared/routes/RoutesComponent'
import 'fontsource-roboto/latin.css'
import { CssBaseline, createTheme } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import { SnackbarProvider, useSnackbar } from 'notistack'
import Message from 'src/view/shared/message'
import settingsSelectors from 'src/modules/settings/settingsSelectors'
import { createMyStore } from 'src/modules/store'
import { useAppSelector } from 'src/modules/hooks'

const store = createMyStore()

export default function App(props) {
  return (
    <Provider store={store}>
      <AppWithRedux {...props} />
    </Provider>
  )
}

function AppWithRedux(props) {
  const settings = useAppSelector(settingsSelectors.selectSettings)
  const settingsTheme = settings.theme
  const isDark = useAppSelector(settingsSelectors.selectIsDark)

  // const contrastBlackOrWhiteTextColot = isDark ? 'white' : 'black'
  // const toolbarColor = isDark ? '#000000' : settingsTheme.primary
  const theme = createTheme({
    palette: {
      primary: {
        main: settingsTheme.primary,
      },
      secondary: {
        main: settingsTheme.secondary,
      },
      mode: isDark ? 'dark' : 'light',
    },
    typography: {
      fontSize: 12.5,
    },
  })

  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider maxSnack={3}>
        <CssBaseline />
        <AppWithSnackbar {...props} />
      </SnackbarProvider>
    </ThemeProvider>
  )
}

function AppWithSnackbar(props) {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()

  useEffect(() => {
    // this is a little hack to not have to import notistack
    // on all the components that emit messages
    Message.registerNotistakEnqueueSnackbar(enqueueSnackbar, closeSnackbar)
  }, [enqueueSnackbar, closeSnackbar])

  return (
    <>
      <BrowserRouter basename={'/'}>
        <RoutesComponent />
      </BrowserRouter>
    </>
  )
}
